module.exports = __webpack_public_path__ + "img/dasaizhuti.e37f4e66.png";